<template>
    <main id="modal" class="flexContainers">
        <loader :loading="loading"></loader>
        <div class="wishlist">
            <header class="wishlist-header"><i class="icon-close" @click="closeModal();"></i></header>
            <div class="modalBody">
                <p class="listTitle">{{ getPlanoName }}</p>
                <div class="list-version">
                    <div
                        v-for="version in this.getPlanoVersion"
                        :key="version.id"
                        class="pointer"
                        @click="beforeOpenPlano(version.id, version.objectId, version.version);"
                    >
                        <div class="content-list">
                            <div class="versionTxt">
                                <p class="bold">{{ $t("versionPlano.version") }} {{ version.version }}</p>
                                <p>{{ $t("versionPlano.saveBy") }} {{ version.username }}</p>
                            </div>
                            <div class="fright">
                                <p class="versionDate">{{ convertGmtToLocal(new Date(version.loggedAt)).toLocaleString() }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loader from "@/components/loader/loader";

export default {
    data() {
        return {
            loading: false
        };
    },
    watch: {},
    components: {
        loader
    },
    mounted() {},
    methods: {
        ...mapActions({
            setRestorePlano: "plano/data/setRestorePlano",
            setRestorePlanoId: "plano/data/setRestorePlanoId",
            setShowRestore: "plano/data/setShowRestore"
        }),
        convertGmtToLocal(dateGmt) {
            let newDate = new Date(dateGmt.getTime() + dateGmt.getTimezoneOffset() * 60000);

            let offset = dateGmt.getTimezoneOffset() / 60;
            let hours = dateGmt.getHours();

            newDate.setHours(hours - offset);

            return newDate;
        },
        closeModal() {
            this.$emit("hideEditPlanoVersion");
        },
        beforeOpenPlano(id, planoId, versionId) {
            this.$router.push(`/planonext/${planoId}?version=${versionId}`);
        }
    },
    computed: {
        ...mapGetters({
            getPlanoVersion: "planos/search/getPlanoVersion",
            getPlanoName: "planos/search/getPlanoName"
        })
    },
    created() {}
};
</script>

<style lang="scss" scoped>
.list-version {
    overflow-y: auto;
    max-height: 500px;
}
.content-list {
    /*padding: 10px;*/
    padding-top: 10px;
    font-size: 20px;
    border-bottom: 1px solid #c2c2c2;
    cursor: pointer;
    background-color: #f3f3f3;
    margin-top: 10px;
    position: relative;
    .versionTxt {
        padding-left: 15px;
        display: inline-block;
    }
    .versionDate {
        padding-right: 15px;
    }
}

#modal {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    z-index: 20000;
    padding-bottom: 20px;
    top: 0;
    left: 0;
    /*margin: auto;*/

    .wishlist {
        padding: 12px;
        position: absolute;
        left: calc(50% - 250px);
        top: 20px;
        display: flex;
        max-height: 650px;
        flex-direction: column;
        height: 100%;
        width: 500px;
        background-color: #fff;
        margin: 10px;
        .wishlist-header {
            .icon-close {
                position: absolute;
                right: 15px;
                top: 15px;
                height: 28px;
                width: 28px;
                background-image: url("../../assets/croix.png");
                background-size: 100% auto;
                cursor: pointer;
            }
            padding-left: 20px;
            .title {
                font-size: 25px;
                font-weight: bold;
                color: #000;
                font-family: "Oswald", Sans-Serif;
                /*padding: 5px 20px;*/
            }

            h3 {
                font-size: 15px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// modalPlanoVersion.vue?f1db7e8a